import { lazy } from 'react';
import MainLayout from 'Layouts/Main/Main';

const BPData = lazy(() => import('Containers/BPData/BPData'));

const routes = [
  {
    path: '/bp-data',
    exact: true,
    ContentComponent: BPData,
    Layout: MainLayout,
    name: 'Patient BP Data',
  },
];

export default routes;
